import { motion } from "framer-motion";
import { Quote } from "lucide-react";

const ABOUT_IMG = "https://images.unsplash.com/photo-1686920355817-2d763176df9a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBob3NwaXRhbCUyMGludGVyaW9yJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc3ODM3MTMzNHww&ixlib=rb-4.1.0&q=85";

export default function Testimonial() {
  return (
    <section id="about" data-testid="testimonial-section" className="relative bg-ab-bg py-24 md:py-32">
      <div className="ab-container grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6 relative">
          <div className="relative aspect-[4/5] overflow-hidden rounded-3xl">
            <img src={ABOUT_IMG} alt="Modern hospital interior" className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-ab-primary/30 to-transparent" />
          </div>
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="absolute -bottom-6 -right-4 md:right-10 bg-white border border-ab-border rounded-2xl p-5 shadow-xl max-w-[260px]"
          >
            <p className="ab-eyebrow text-ab-muted">Time saved per week</p>
            <p className="font-serif text-5xl text-ab-primary mt-1">412 hrs</p>
            <p className="text-xs text-ab-muted mt-2">Across nursing & front-office staff</p>
          </motion.div>
        </div>

        <div className="lg:col-span-6">
          <Quote className="w-12 h-12 text-ab-accent" />
          <blockquote className="mt-6 font-serif text-3xl md:text-5xl leading-tight text-ab-primary">
            "Our 120-bed hospital used to feel like five different companies. With PranaOs, the floor moves like one team — and our discharge time dropped from 4 hours to 47 minutes."
          </blockquote>
          <div className="mt-10 flex items-center gap-4">
            <div className="w-12 h-12 rounded-full bg-ab-primary text-white font-serif flex items-center justify-center">DR</div>
            <div>
              <p className="font-medium text-ab-text">Dr. Ramesh Iyer</p>
              <p className="text-sm text-ab-muted">Medical Superintendent · Lifeline Hospitals</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
